import {
  setHint
} from './functions.js';

export default class Firstname {
  constructor(args) {
    this.translations = translations.registrationForm;

    this.container = args.container;
    this.inputField = this.container.querySelector('input.firstname');
    this.hintOut = this.container.querySelector('.hint');

    this.setHint = setHint.bind(this);

    this.errorClass = 'invalid';

    this.addEvents();
  }

  addEvents() {
    this.inputField.addEventListener('change', e => {
      this.inputField.classList.remove(this.errorClass);
      this.setHint();
    });
  }

  get value() {
    return this.inputField.value;
  }

  validate() {
    const hints = [];
    const invalidFields = new Set();

    if (this.value.length < 2) {
      hints.push({
        type: 'alert',
        text: this.translations.firstnameEmptyError
      });
      invalidFields.add(this.inputField);
    }

    this.setHint(hints);

    [...invalidFields].map(field => field.classList.add(this.errorClass));

    return invalidFields.size === 0;
  }
}